import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { CustomPicker } from 'react-color'
import colorHelper from 'react-color/lib/helpers/color'
import { EditableInput, Saturation, Hue } from 'react-color/lib/components/common/'

// components
import ManagedRenderComponent from '@aytm/lib/common/components/ManagedRenderComponent'

// styles
import '@aytm/lib/rfd-ui/styles/advanced/color-picker.scss'

export class PointerSaturation extends ManagedRenderComponent {
  render() {
    return <div className={'rfd-ui-colorpicker-pointerSaturation'} />
  }
}

export class PointerHue extends ManagedRenderComponent {
  render() {
    return (
      <div className={'rfd-ui-colorpicker-pointerHue'}>
        <div className={'rfd-ui-colorpicker-pointerHue-dots'} />
        <div className={'rfd-ui-colorpicker-pointerHue-arrow'} />
      </div>
    )
  }
}

class ColorPicker extends Component {
  static propTypes = {
    color: PropTypes.string.isRequired,
    readOnly: PropTypes.bool,
    onChange: PropTypes.func.isRequired
  }

  constructor(...args) {
    super(...args);
    this.onInputChange = this.onInputChange.bind(this);
  }

  onInputChange(value) {
    const { onChange } = this.props
    if (value.hex) {
      colorHelper.isValidHex(value.hex) && onChange(value)
    }
  }

  render() {
    const { color, readOnly, onChange } = this.props

    return (
      <div className={'rfd-ui-colorpicker'}>
        <div className={`rfd-ui-colorpicker-field ${readOnly ? 'rfd-ui-colorpicker-disabled' : ''}`}>
          <EditableInput
            {...this.props}
            label="hex"
            value={color.toUpperCase()}
            onChange={readOnly ? null : this.onInputChange}
          />
        </div>
        <div className={`rfd-ui-colorpicker-settings ${readOnly ? 'rfd-ui-colorpicker-disabled' : ''}`}>
          <div className={'rfd-ui-colorpicker-saturation'}>
            <Saturation {...this.props} onChange={readOnly ? null : onChange} pointer={PointerSaturation} />
          </div>
          <div className={'rfd-ui-colorpicker-hue'}>
            <Hue {...this.props} direction="vertical" onChange={readOnly ? null : onChange} pointer={PointerHue} />
          </div>
        </div>
      </div>
    )
  }
}

export default CustomPicker(ColorPicker)
